export default "__VITE_ASSET__DY$8MQUl__"